import * as icons from '@ant-design/icons-vue';
import * as iconParkIcons from '@icon-park/vue-next';

// console.log('icons', icons,);
console.log('iconParkIcons', iconParkIcons,);

export default {
    install: (app) => {
        // antdv 图标
        const iconComponents = []
        for (const key in icons) {
            const component = icons[key];
            if (component.displayName) {
                iconComponents[component.displayName] = component;
            }
        }
        // console.log('iconComponents', iconComponents);
        app.config.globalProperties.$icons= iconComponents;

        // iconPark图标
        // const iconParkComponents = {};
        // for (const key in iconParkIcons) {
        //     const component = iconParkIcons[key];
        //     if (typeof component === 'function') {
        //         iconParkComponents[key] = component;
        //     }
        // }
        // console.log('iconParkComponents', iconParkComponents);
        // app.config.globalProperties.$iconsPark= iconParkComponents;

    },
};